import { Outlet, useNavigate, useLocation, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LogOut, ChevronLeft, Clock3, CalendarDays, Home } from "lucide-react";
import { OrgStatusBanner } from "@/components/OrgStatusBanner";
import { NotificationCenter } from "@/components/NotificationCenter";
import { OfflineBanner } from "@/components/OfflineBanner";

// Personnel administratif : espace réduit (Mes heures, Congés & demandes, profil, déconnexion). Aucun autre module n'est accessible.
export default function StaffLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const isHome = loc.pathname === "/staff";
  const tabs = [{ to: "/staff", label: "Accueil", icon: Home, end: true, testid: "staff-nav-home" }, { to: "/staff/heures", label: "Mes heures", icon: Clock3, testid: "staff-nav-hours" }, { to: "/staff/conges", label: "Congés", icon: CalendarDays, testid: "staff-nav-leaves" }];
  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-background pb-24 relative" data-testid="staff-layout">
      <header className="sticky top-0 z-20 bg-slate-900 text-white shadow-md">
        <div className="flex items-center justify-between px-4 h-14">
          {isHome ? <Logo size={32} onDark /> : <button data-testid="staff-back" onClick={() => nav(-1)} className="flex items-center gap-1 text-white font-semibold -ml-1 active:scale-95 transition-transform"><ChevronLeft className="w-6 h-6" /> Retour</button>}
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-slate-200" data-testid="staff-user-name">{user?.first_name}</span>
            <div className="[&_button[data-testid=notif-bell]]:bg-white/10 [&_button[data-testid=notif-bell]]:text-white [&_button[data-testid=notif-bell]]:w-9 [&_button[data-testid=notif-bell]]:h-9"><NotificationCenter /></div>
            <button data-testid="staff-logout" onClick={() => { logout(); nav("/login"); }} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white active:scale-95 transition-transform"><LogOut className="w-4 h-4" /></button>
          </div>
        </div>
      </header>
      <OrgStatusBanner />
      <OfflineBanner />
      <main className="px-4 pt-4 animate-fade-in"><Outlet /></main>
      <nav className="fixed bottom-0 inset-x-0 z-20 bg-white border-t border-slate-200" data-testid="staff-bottom-nav">
        <div className="max-w-md mx-auto grid grid-cols-3">
          {tabs.map((t) => <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid} className={({ isActive }) => `flex flex-col items-center gap-0.5 py-2.5 text-[11px] font-bold ${isActive ? "text-slate-900" : "text-slate-400"}`}><t.icon className="w-5 h-5" />{t.label}</NavLink>)}
        </div>
      </nav>
    </div>
  );
}
